import $ from 'jquery';
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

window.gridBreakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};

$(function () {
    window.initSlider();
});


/**
 * Slider container element
 */
window.initSlider = function ($object = null) {


    if (null === $object) {
        $object = $('.creative-slider')
    } else if (!$($object).is('creative-slider')) {
        $object = $($object).find('.creative-slider')
    }


    $object.each(function () {
        const $container = $(this).find('.swiper');
        const $prev = $(this).find('.swiper-button-prev');
        const $next = $(this).find('.swiper-button-next');
        const $pagination = $(this).find('.swiper-pagination');

        const $toggleArrows = $container.find($('.slider-item-toggle-text'));
        const $toggleContents = $container.find($('.slider-item-text'));

        $toggleContents.addClass('hidden');

        $toggleArrows.on('click', function () {
            $toggleArrows.toggleClass('opened');
            $toggleContents.toggleClass('hidden');
        });

        let dataLoop = false;
        if ($container.data('loop') && true === $container.data('loop')) {
            dataLoop = true;
        }

        let centeredSlides = false;
        if ($container.data('centered') && true === $container.data('centered')) {
            centeredSlides = true;
        }

        new Swiper($container[0], {
            direction: 'horizontal',
            loop: dataLoop,
            speed: 600,
            slidesPerView: 1, // Fallback
            centeredSlides: centeredSlides,
            spaceBetween: 32,
            autoHeight: false,
            wrapperClass: 'creative-slider-wrapper',
            slideClass: 'creative-slide',
            containerModifierClass: 'slider-container-',
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    centeredSlides: false
                },
                768: {
                    slidesPerView: 2,
                    centeredSlides: false
                },
                992: {
                    slidesPerView: 3,
                    centeredSlides: true // optional nur hier aktivieren
                }
            }
        });

    });

};
